import { render, staticRenderFns } from "./AccountMailboxSectionView.vue?vue&type=template&id=54b64384&"
import script from "./AccountMailboxSectionView.vue?vue&type=script&lang=js&"
export * from "./AccountMailboxSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b64384')) {
      api.createRecord('54b64384', component.options)
    } else {
      api.reload('54b64384', component.options)
    }
    module.hot.accept("./AccountMailboxSectionView.vue?vue&type=template&id=54b64384&", function () {
      api.rerender('54b64384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/account/AccountMailboxSectionView.vue"
export default component.exports